import * as React from 'react';
import styled from 'styled-components';
import * as moment from 'moment';
import * as numeral from 'numeral';
import * as AutoLinker from 'autolinker';
import { colors } from 'kaizen-ui-colors/lib';
import {
  IExperience,
  IRoundInfo,
  modeLabel,
  modeLabelColor,
  roundLabel,
} from '../../domain/entity/PortfolioReportItem';
import config from '../../config';
import { Dot } from './Dot';
import { Text } from './Text';

interface IProps {
  round: IRoundInfo;
  experience: IExperience;
  selectedGoalId: string;
}

const Wrapper = styled.div`
  margin: 24px;
`;

const RoundNoteLayout = styled.div`
  display: grid;
  grid-template-columns: 60% 1fr;
  grid-template-rows: auto auto;
  grid-column-gap: 16px;
  grid-row-gap: 8px;
`;

const RoundNoteLabel = styled.div`
  display: inline-block;
  margin-bottom: 12px;
  padding: 4px 12px;
  background-color: ${colors.lithium__dbe0eb};
  font-weight: 700;
  border-radius: 4px;
`;

const RoundNote = styled.div`
  border: 1px solid ${colors.lithium__dbe0eb};
  border-radius: 4px;
  padding: 8px;
  height: 100%;
  background-color: #fff;
`;

const RoundNoteBody = styled.div`
  padding: 4px;
`;

const AutoLinkerOptions = {
  newWindow: true,
  stripPrefix: false,
};

export class RoundInfoDetail extends React.Component<IProps, {}> {
  private renderImprovementRate(improvementRate: number) {
    const color =
      improvementRate && improvementRate > 100
        ? colors.veggie__2dcc70
        : improvementRate < 100 ? colors.lava__fe7877 : 'inherit';
    return (
      <Text numeric>
        <span style={{ color }}>{numeral(improvementRate).format('0.0')}%</span>
      </Text>
    );
  }

  public render() {
    const { round, experience, selectedGoalId } = this.props;
    const editUrl = `${config.dashboard}/experiments/${experience.id}?tab=report&round_id=${
      round.id
    }&goal_id=${selectedGoalId}`;
    const mode = round.roundState.type === 'paused' ? round.roundState.type : round.purposeType;
    return (
      <Wrapper>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
          <Dot color={modeLabelColor(mode)} />
          <Text>
            <strong>{roundLabel(round.type, round.num)}</strong>
          </Text>
          <Text size={'small'} style={{ marginRight: '1rem', marginLeft: '0.5rem' }}>
            （{modeLabel(mode)}）
          </Text>
          <Text style={{ marginRight: '2rem' }}>
            改善率：
            {this.renderImprovementRate(round.improvementRatio)}
          </Text>
          {moment(round.startedAt).format('YYYY/MM/DD')} -{' '}
          {round.endedAt ? moment(round.endedAt).format('YYYY/MM/DD') : ''}
        </div>
        <RoundNoteLayout>
          <RoundNote>
            <RoundNoteLabel>テストの目的</RoundNoteLabel>
            <RoundNoteBody
              dangerouslySetInnerHTML={{
                __html:
                  AutoLinker.link(round.note, AutoLinkerOptions) || `<a href=${editUrl} target="_blank">記入する</a>`,
              }}
            />
          </RoundNote>
          <RoundNote>
            <RoundNoteLabel>結果・考察</RoundNoteLabel>
            <RoundNoteBody
              dangerouslySetInnerHTML={{
                __html:
                  AutoLinker.link(round.resultNote, AutoLinkerOptions) ||
                  `<a href=${editUrl} target="_blank">記入する</a>`,
              }}
            />
          </RoundNote>
        </RoundNoteLayout>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/RoundInfoDetail.tsx